//export const backupServer = "https://jetocrm-server.azurewebsites.net";
//export const backupServer = "https://web-production-6467.up.railway.app";
//export let backupServer="https://jetovacation.com"
//export let backupServer="https://jeto-crm-server.onrender.com"
export const backupServer ="https://jetocrmserver-cbf5081ff15c.herokuapp.com/"
//export let backupServer="http://localhost:5000"
//export const backupServer="https://www.jetovacations.in"

//export let primaryServer="https://www.jetovacations.in"
export let primaryServer="https://web-production-6467.up.railway.app"
//export const primaryServer ="https://jetocrmserver-cbf5081ff15c.herokuapp.com/"
//export let primaryServer="https://3.108.245.168:5000"
//export let primaryServer="https://jetocrm-server.azurewebsites.net"
//export let primaryServer="https://jeto-crm-server.onrender.com"
//export let primaryServer="https://jetocrm-project.herokuapp.com"
//export let primaryServer="http://jeto-crm-server2025-env.eba-y4bdyuat.ap-south-1.elasticbeanstalk.com/"
//export let primaryServer="http://localhost:5000"

export const getActiveServer = () => activeServer;
export let servermarker=false
export let activeServer = primaryServer;
console.log(activeServer)


export const switchToBackup = () => {
  if (activeServer !== backupServer) {
    console.log("❌ Primary down → switching to backup...");
    activeServer = backupServer;
    console.log("Now activeServer =", activeServer);
     servermarker=true
  }
};

export const switchToPrimary = () => {
  if (activeServer !== primaryServer) {
    console.log("✅ Primary is back → switching to primary...");
    activeServer = primaryServer;
    servermarker=false
  }
};

// Check both servers intelligently
export const checkServerHealth = async () => {
  try {
    // always check primary first
    const res = await fetch(`${primaryServer}/healthcheck`, { method: "GET" });
    if (res.ok) {
      console.log("✅ Server healthy");
      switchToPrimary(); // go back if primary is healthy
      return;
    }
  } catch (err) {
    // if primary fails, try backup
    try {
      const backupRes = await fetch(`${backupServer}/healthcheck`, { method: "GET" });
      if (backupRes.ok) {
        console.log("✅ Backup Server healthy");
        switchToBackup();
      }
    } catch (err2) {
      console.error("❌ Both servers unreachable");
    }
  }
};